// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/widgets/MainMenu/styles.scss
// module id = 812
// module chunks = 0